export const questions: Array<[string, string]> = [
  [
    'Who is it for?',
    'Fire protection technicians and inspectors, sprinkler fitters, fire alarm and suppression system technicians, maintenance technicians, HSE officers, plant engineers, junior fire protection engineers and designers, and advanced students.',
  ],
  [
    'Content depth?',
    'From fire science fundamentals to detection, sprinklers, water supply, special hazards, inspection, testing, maintenance and industrial fire protection operations.',
  ],
  [
    'International?',
    'Yes. Based on internationally used concepts and terminology; always follow the codes and standards that apply where you work.',
  ],
  [
    'Does it replace codes or professionals?',
    'No. It is a technical reference. It does not replace the applicable standards and codes, the authority having jurisdiction (AHJ), manufacturer instructions or the judgment of qualified, licensed professionals.',
  ],
  [
    'Format?',
    'Professional PDF technical reference files with instant access. It is not software, a simulator, editable spreadsheets or a certificate course.',
  ],
  ['Currency?', 'USD. Auto-converts to your local currency.'],
  ['Not satisfied?', '7-day refund. 100% money back.'],
];
